import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { getSessionStatus } from '../../services/checkout.service';
import Button from '../Button';
import { getSelf } from '../../services/auth.service';
import { useAuth } from '../../contexts/AuthContext';

const CheckoutReturn = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<string | null>(null);
  const [customerEmail, setCustomerEmail] = useState('');
  const navigate = useNavigate();
  const { refresh: refreshAuthContext } = useAuth();

  useEffect(() => {
    const fetchStatus = async () => {
      const sessionId = searchParams.get('session_id');

      if (!sessionId) {
        setStatus('no-session');
        return;
      }

      const result = await getSessionStatus(sessionId);

      if (result.success && result.data) {
        setStatus(result.data.status);
        setCustomerEmail(result.data.customerEmail);
        const selfResult = await getSelf();
        if (selfResult.success && selfResult.data) {
          refreshAuthContext();
        }
      }
    };

    fetchStatus();
  }, []);

  if (status === 'no-session') {
    return (
      <section id="success">
        <p>
          The transaction could not be completed. Please email{' '}
          <a href="mailto:vieweventnotes@bungalow64.co.uk">
            vieweventnotes@bungalow64.co.uk
          </a>
          .
        </p>
      </section>
    );
  }

  if (status === 'open') {
    return <Navigate to="/checkout" />;
  }

  if (status === 'complete') {
    return (
      <section id="success">
        <p>
          Thank you, your account has been updated. A confirmation email will be
          sent to {customerEmail}. If you have any questions, please email{' '}
          <a href="mailto:vieweventnotes@bungalow64.co.uk">
            vieweventnotes@bungalow64.co.uk
          </a>
          .
        </p>
        <Button onClick={() => navigate('/account/details')}>Continue</Button>
      </section>
    );
  }

  if (status === 'pending') {
    return (
      <section id="success">
        <p>
          Thank you. Your subscription is being processed, and a confirmation
          email will be sent to {customerEmail} once completed. If you have any
          questions, please email{' '}
          <a href="mailto:vieweventnotes@bungalow64.co.uk">
            vieweventnotes@bungalow64.co.uk
          </a>
          .
        </p>
      </section>
    );
  }

  return null;
};

export default CheckoutReturn;
